export default __webpack_public_path__ + "static/media/sample-import.a60732e0.csv";